import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6464e16"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "report-room-modal",
  "data-keyboard": "true",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "report-room-modal-label",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "report-room-modal-label"
  }, "Add Rooms"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1))
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  class: "nav nav-tabs",
  id: "new-room-tabs",
  role: "tablist"
}
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = {
  class: "tab-content mt-4",
  id: "new-room-tabs-content"
}
const _hoisted_10 = {
  class: "tab-pane fade show active",
  id: "new-room-add",
  role: "tabpanel",
  "aria-labelledby": "home-tab"
}
const _hoisted_11 = { class: "form-group row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Room Type", -1))
const _hoisted_13 = { class: "col-sm-9" }
const _hoisted_14 = { class: "form-group row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Room Name", -1))
const _hoisted_16 = { class: "col-sm-9" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  class: "tab-pane fade",
  id: "new-room-copy",
  role: "tabpanel",
  "aria-labelledby": "new-room-tab-copy"
}
const _hoisted_19 = { class: "mb-0" }
const _hoisted_20 = { class: "form-group row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, " Report ID ", -1))
const _hoisted_22 = { class: "col-sm-9" }
const _hoisted_23 = { class: "input-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-outline-secondary",
    type: "submit"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
  ])
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_26 = { class: "form-group row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Rooms", -1))
const _hoisted_28 = {
  key: 0,
  class: "col-sm-9"
}
const _hoisted_29 = { class: "col-form-label d-block" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-2 mb-0" }, null, -1))
const _hoisted_31 = ["id", "value"]
const _hoisted_32 = {
  key: 1,
  class: "col-sm-9"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label d-block text-muted" }, " Select a Report with Rooms to copy. ", -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "modal-footer" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["disabled"]

import { computed, inject, ref, onMounted, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import { Report, Room } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportRoomModal',
  setup(__props) {

const instance = getCurrentInstance();

const store = useStore();
const toasted = useToast();
const actProperty: any = inject('actProperty');

const report = computed(() => store.getters['reports/current']);
const roomsToCopy = computed((): Room[] => store.getters['reports/roomsToCopy']);
const roomsByPriorityFromMainDictionary = computed(() => store.getters['dictionary/roomsByPriority']);
const roomsByPriorityFromCustomerDictionary = computed(() => store.getters['customerdictionary/roomsByPriority']);

const tab = ref("new");
const name = ref("");
const room = ref(new Room());
const reportRef = ref("");
const selectedRoomIndexes = ref<number[]>([]);

const getSourceReport = async (ref: string): Promise<any> => {
  return store.dispatch('reports/getSourceReport', ref);
};

const addRoom = async (payload: { room: Room; name: string }): Promise<any> => {
  return store.dispatch('reports/addRoom', payload);
};

const copyRooms = async (payload: { rooms: Room[]; targetIndex: number }): Promise<any> => {
  return store.dispatch('reports/copyRooms', payload);
};

const roomsByPriority = computed(() => {
  return actProperty.isFactoryreport(report.value.type) 
    ? roomsByPriorityFromCustomerDictionary.value 
    : roomsByPriorityFromMainDictionary.value;
});

onMounted(async () => {
  reset();
});

const reset = () => {
  name.value = "";
  room.value = new Room();
  selectedRoomIndexes.value = [];
};

const setTab = (val: string) => {
  tab.value = val;
};

const forceUpdate = () => {
  instance?.proxy?.$forceUpdate();
};

const onSelectNewRoom = (val: Room) => {
  //room.value = val;
  name.value = val.name;
};

const add = () => {
  addRoom({ room: room.value, name: name.value })
      .then(() => toasted.success(`Added`))
      .then(() => reset())
      .catch((err: any) => actProperty.displayError(err));
};

const setAllRooms = (event: any) => {
  if (event.target.checked) {
    selectedRoomIndexes.value = roomsToCopy.value.map((_, index) => index);
  } else {
    selectedRoomIndexes.value = [];
  }
  forceUpdate();
};

const getReportToCopy = (ref: string) => {
  getSourceReport(ref);
};

const copy = () => {
  const rooms = roomsToCopy.value.filter((val, index) =>
    selectedRoomIndexes.value.includes(index)
  );
  // TODO copy Rooms at a specific index?
  const targetIndex = 0;
  copyRooms({ rooms, targetIndex })
    .then(() => toasted.success(`Copied`))
    .then(() => reset())
    .catch((err: any) => actProperty.displayError(err));
};

return (_ctx: any,_cache: any) => {
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("a", {
                class: "nav-link active",
                id: "new-room-tab-add",
                "data-toggle": "tab",
                href: "#new-room-add",
                role: "tab",
                "aria-controls": "new-room-add",
                "aria-selected": "true",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (setTab('new')))
              }, " New Room ")
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createElementVNode("a", {
                class: "nav-link",
                id: "new-room-tab-copy",
                "data-toggle": "tab",
                href: "#new-room-copy",
                role: "tab",
                "aria-controls": "new-room-copy",
                "aria-selected": "false",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (setTab('copy')))
              }, " Copy Rooms ")
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_multiselect, {
                      modelValue: room.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((room).value = $event)),
                      "track-by": "name",
                      options: roomsByPriority.value,
                      onSelect: onSelectNewRoom
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((name).value = $event)),
                      disabled: room.value == null
                    }, null, 8, _hoisted_17), [
                      [_vModelText, name.value]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("fieldset", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("form", {
                      onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (getReportToCopy(reportRef.value)), ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_23, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((reportRef).value = $event)),
                          placeholder: "This Report"
                        }, null, 512), [
                          [_vModelText, reportRef.value]
                        ]),
                        _hoisted_24
                      ])
                    ], 32)
                  ])
                ]),
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  (roomsToCopy.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_29, [
                            _createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              id: "set-all-rooms",
                              onChange: setAllRooms
                            }, null, 32),
                            _createTextVNode(" Select All ")
                          ])
                        ]),
                        _hoisted_30,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roomsToCopy.value, (room, $index) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: $index,
                            class: "col-form-label d-block"
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              id: `room-${$index}`,
                              value: $index,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedRoomIndexes).value = $event)),
                              onChange: forceUpdate
                            }, null, 40, _hoisted_31), [
                              [_vModelCheckbox, selectedRoomIndexes.value]
                            ]),
                            _createTextVNode(" " + _toDisplayString(room.name), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          (tab.value === 'new')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary",
                "data-dismiss": "modal",
                onClick: add,
                disabled: !room.value || !name.value
              }, " Add Room ", 8, _hoisted_36))
            : _createCommentVNode("", true),
          (tab.value === 'copy')
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-primary",
                "data-dismiss": "modal",
                onClick: copy,
                disabled: selectedRoomIndexes.value.length === 0
              }, " Copy " + _toDisplayString(selectedRoomIndexes.value.length) + " Room" + _toDisplayString(selectedRoomIndexes.value.length === 1 ? "" : "s"), 9, _hoisted_37))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})